/** Generated js for domain-specific scripting
 * by common\modules\domains\helpers\DomainJavascriptWriter
 */

/* expander */

document.addEventListener('click', function (event) {
  const isExpandButton =
    event.target.matches('.expand-button') ||
    event.target.closest('.expand-button') !== null;

  const expanderParent = event.target.closest('.expander');

  if (isExpandButton && expanderParent) {
    event.preventDefault();
    toggleExpander(expanderParent, true);
  }
});

function toggleExpander(expanderElement, toggle) {
  if (toggle) {
    expanderElement.classList.toggle('expand');
  }
  let maxHeight = '999em';
  if (!expanderElement.classList.contains('expand')) {
    maxHeight = expanderElement.dataset.minimalHeight ?? '50px';
  }
  const contentElement = expanderElement.querySelector('.expander-content');
  if (contentElement) {
    contentElement.style.maxHeight = maxHeight;
  }
}

document.querySelectorAll('.expander').forEach(expander => {
  toggleExpander(expander, false);
});
